import axios from "axios";

// Axios client for the storefront API: every request carries the store slug and the shopper token
export const TOKEN_KEY = "gn_token";
export const USER_KEY = "gn_user";

// /api is proxied to the backend: by nginx in Docker, by the "proxy" field in package.json for `npm start`.
// Set REACT_APP_API_URL to call a backend on another origin instead.
const baseURL = process.env.REACT_APP_API_URL || "/api";

// Which store this storefront is. Normally nothing is sent and the backend picks the store from the
// address (<slug>.ownezzy.com, or the store's own domain), so one build serves every store.
// REACT_APP_STORE_SLUG pins one store; on localhost (no store address) the GreenNest demo store is used.
const LOCAL_HOSTS = ["localhost", "127.0.0.1"];
export const STORE_SLUG = process.env.REACT_APP_STORE_SLUG || (LOCAL_HOSTS.includes(window.location.hostname) ? "greennest" : "");

export const client = axios.create({ baseURL });

client.interceptors.request.use((config) => {
    if (STORE_SLUG) config.headers["x-store-slug"] = STORE_SLUG;
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers["x-auth-token"] = token;
    return config;
});

// A 401 on a request that carried a token means the session ended (expired, logged out elsewhere,
// blocked). A 401 on login itself just means wrong credentials, so that one is left alone.
client.interceptors.response.use(
    (response) => response,
    (error) => {
        const sentToken = Boolean(error.config && error.config.headers && error.config.headers["x-auth-token"]);
        if (error.response && error.response.status === 401 && sentToken) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
            window.dispatchEvent(new Event("gn:unauthorized"));
        }
        return Promise.reject(error);
    }
);

// The message to show the shopper for a failed request
export const errorMessage = (error) => {
    if (error && error.response && error.response.data && error.response.data.message) return error.response.data.message;
    if (error && error.response && error.response.status >= 500) return "Something went wrong on our side. Please try again.";
    if (error && error.request && !error.response) return "Can't reach the store right now. Check your connection and try again.";
    return "Something went wrong. Please try again.";
};

export default client;
